import React from 'react';
export const RefundPolicy = () => {
  return <div className="bg-white" data-id="element-537">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-538">
        <div className="text-center" data-id="element-539">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-540">
            Refund Policy
          </h1>
          <p className="mt-4 text-xl text-gray-500 max-w-3xl mx-auto" data-id="element-541">
            Information about refunds for Suretask service plans.
          </p>
        </div>
        <div className="mt-12 max-w-4xl mx-auto" data-id="element-542">
          <div className="prose prose-rose max-w-none" data-id="element-543">
            <h2 data-id="element-544">Refund Policy – Suretask</h2>
            <p data-id="element-545">
              Thank you for choosing Suretask. We value your trust and are
              committed to ensuring your complete satisfaction with our
              services. If you have any concerns about your service plan or
              purchase, we'll work quickly and fairly to resolve them.
            </p>
            <h3 data-id="element-546">Cancellation & Refund Rights</h3>
            <p data-id="element-547">
              You have the right to cancel your service plan within 14 days of
              purchase and receive a full refund. To do this, please contact us
              within the 14-day period, and we'll process your refund promptly.
            </p>
            <p data-id="element-548">
              If you cancel after 14 days but within 28 days of purchase, you
              may be eligible for a partial refund at our discretion, depending
              on any services already provided under your plan.
            </p>
            <p data-id="element-549">
              Please note that refunds or cancellations are not available after
              28 days from the purchase date. We recommend reviewing your
              service plan carefully and contacting us as soon as possible if
              you wish to cancel.
            </p>
            <h3 data-id="element-550">How to Request a Refund</h3>
            <p data-id="element-551">
              To request a refund, please get in touch with our team using the
              contact details below:
            </p>
            <ul data-id="element-552">
              <li data-id="element-553">Phone: 0800 055 4969</li>
              <li data-id="element-554">Email: angelene18inandan@gmail.com</li>
            </ul>
            <p data-id="element-555">
              We'll assess your request promptly and process any approved
              refunds. You'll receive confirmation once your refund has been
              completed.
            </p>
            <h3 data-id="element-556">Payment Methods</h3>
            <p data-id="element-557">Suretask accepts payments via:</p>
            <ul data-id="element-558">
              <li data-id="element-559">Phone card payments</li>
              <li data-id="element-560">Online payments through our website</li>
              <li data-id="element-561">BACS or Direct Debit</li>
            </ul>
            <p data-id="element-562">
              Your 14-day cancellation right applies regardless of payment
              method.
            </p>
            <h3 data-id="element-563">Refund Processing</h3>
            <p data-id="element-564">
              All refunds will be issued to the original payment method used at
              purchase. For security reasons, refunds cannot be made to
              alternative accounts or cards.
            </p>
            <h3 data-id="element-565">Payment Follow-Up</h3>
            <p data-id="element-566">
              After purchasing a plan, Suretask will contact you to confirm
              activation and inform you when payment will be processed. Please
              ensure sufficient funds are available. If payment fails, we'll
              contact you to confirm whether you wish to proceed. Without a
              timely response, your plan will be cancelled.
            </p>
            <h3 data-id="element-567">Authorised Payments</h3>
            <p data-id="element-568">
              Payments must be made by the plan holder or an authorised
              individual. We don't accept payments made under power of attorney
              or other third-party authorisations.
            </p>
            <h3 data-id="element-569">Claims & Support</h3>
            <p data-id="element-570">
              To book a repair or submit a claim for your appliance, please
              contact us immediately:
            </p>
            <ul data-id="element-571">
              <li data-id="element-572">Email: angelene18inandan@gmail.com</li>
              <li data-id="element-573">Phone: 0800 055 4969</li>
            </ul>
            <p data-id="element-574">
              Our team will assist you and begin the repair process promptly.
            </p>
            <h3 data-id="element-575">Dispute Resolution</h3>
            <p data-id="element-576">
              If you have any issues related to payment or service, please
              contact Suretask first before raising a chargeback with your bank.
              We aim to resolve all concerns fairly and promptly. Initiating a
              chargeback without prior contact may delay your refund.
            </p>
          </div>
        </div>
      </div>
    </div>;
};